import { render } from "./order-status-content.vue?vue&type=template&id=406befea&scoped=true"
import script from "./order-status-content.vue?vue&type=script&lang=js"
export * from "./order-status-content.vue?vue&type=script&lang=js"

import "./order-status-content.vue?vue&type=style&index=0&id=406befea&scoped=true&lang=css"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-406befea"]])

export default __exports__